import React, { useRef, useEffect } from "react";
import { Text, Transformer } from "react-konva";

const TextElement = ({ 
  id, 
  x, 
  y, 
  text, 
  fontFamily, 
  fontSize, 
  fontColor, 
  isSelected, 
  onSelect, 
  onChange,
  drawingMode
}) => {
  const textRef = useRef();
  const trRef = useRef();

  useEffect(() => {
    if (isSelected && textRef.current && trRef.current) {
      trRef.current.nodes([textRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  const handleTransform = () => {
    if (textRef.current) {
      const node = textRef.current;
      const scaleX = node.scaleX();
      const scaleY = node.scaleY();
      
      // Use the average scale for more balanced resizing
      // This makes the text resize more predictably in both directions
      const averageScale = (scaleX + scaleY) / 2;
      const newFontSize = Math.max(8, Math.round(fontSize * averageScale));
      
      onChange({
        x: node.x(),
        y: node.y(),
        fontSize: newFontSize,
        scaleX: 1,
        scaleY: 1,
      });
    }
  };

  return (
    <>
      <Text
        ref={textRef}
        id={id}
        x={x}
        y={y}
        text={text}
        fontFamily={fontFamily}
        fontSize={fontSize}
        fill={fontColor}
        draggable={!drawingMode}
        onClick={onSelect}
        onTap={onSelect}
        onDragEnd={(e) => {
          onChange({ x: e.target.x(), y: e.target.y() });
        }}
        onTransform={(() => {
          return () => {
            const node = textRef.current;
            if (!node) return;
            const scaleX = node.scaleX();
            const scaleY = node.scaleY();
            const averageScale = (scaleX + scaleY) / 2;
            const newFontSize = Math.max(8, Math.round(fontSize * averageScale));
            // reset scale so transformer handles stay where the mouse releases
            node.scaleX(1);
            node.scaleY(1);
            onChange({ fontSize: newFontSize, x: node.x(), y: node.y() });
          };
        })()}
        onTransformEnd={handleTransform}
      />
      {isSelected && (
        <Transformer
          ref={trRef}
          rotateEnabled={true}
          enabledAnchors={["top-left", "top-right", "bottom-left", "bottom-right"]}
          boundBoxFunc={(oldBox, newBox) => {
            // Limit minimum size to prevent text from becoming too small
            const minSize = 20;
            if (newBox.width < minSize || newBox.height < minSize) {
              return oldBox;
            }
            return newBox;
          }}
        />
      )}
    </>
  );
};

export default TextElement;
